import { useMemo } from 'react';
import { isAccessTokenExpired } from '../Services/Oauth2Service';
import FetchClient from '@cb/common-ts/FetchClient';
import useAuthService from './UseAuthService';
import { useTokenStore } from './UseTokenStore';
import useConfiguration from './UseConfiguration';
export default function useAuthenticatedFetchClient() {
    const tokenStore = useTokenStore();
    const authService = useAuthService();
    const config = useConfiguration();
    const fetchClient = useMemo(() => createAuthenticatedFetchClient(`${config.serviceConfig.platformCoreApiRoot}/api`, tokenStore, authService), [config.serviceConfig.platformCoreApiRoot, tokenStore, authService]);
    return fetchClient;
}
export function createAuthenticatedFetchClient(platformCoreApiRoot, tokenStore, codebotsOauth2Service) {
    return new FetchClient({
        baseUrl: platformCoreApiRoot,
        optionsCallback: async () => {
            await tokenStore.ensureLoaded();
            let token = tokenStore.getState('tokenData');
            // Add token to request if we have one
            if (token) {
                // Handle refresh token flow if our token is expired
                if (isAccessTokenExpired(token)) {
                    console.log('Token expired, using refresh token to acquire new access token.');
                    try {
                        token = await codebotsOauth2Service.getTokenFromRefreshToken(token);
                        tokenStore.setState('tokenData', token);
                    }
                    catch {
                        tokenStore.setState('tokenData', null);
                        console.error('Failed to get access token from refresh token, refreshing page');
                        window.location.reload();
                        return {};
                    }
                }
                if (token) {
                    return {
                        headers: {
                            Authorization: `Bearer ${token.access_token}`,
                        },
                    };
                }
            }
            return {};
        },
    });
}
//# sourceMappingURL=UseAuthenticatedFetchClient.js.map